export const memberPathPrefix = "/mp";
export const memberSettingsPathPrefix = "/mp/settings";
